import DescriptionIcon from '@mui/icons-material/Description';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import SearchIcon from '@mui/icons-material/Search';
import SettingsIcon from '@mui/icons-material/Settings';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { memo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../../../../redux/hooks';
import LogoutButton from '../../../Topbar/components/LogoutButton';
import NavItem from './components/NavItem/NavItem';

interface NavItemType {
  title: string;
  href: string;
  icon: React.ComponentType<any>;
  permission?: string[];
}

const navMenu: NavItemType[] = [
  {
    title: 'Protocolos',
    href: '/protocols',
    icon: DescriptionIcon,
  },
  {
    title: 'Procedimientos Quirúrgicos',
    href: '/surgical-procedures',
    icon: LocalHospitalIcon,
  },
  {
    title: 'Búsqueda',
    href: '/search',
    icon: SearchIcon,
  },
];

const SidebarNav = () => {
  const { user } = useAppSelector(state => state.user);
  const navigate = useNavigate();
  const location = useLocation();

  const handleConfigClick = () => {
    navigate('/admin/settings');
  };

  const filteredNavMenu = navMenu.filter(item => {
    if (item.permission) {
      return item.permission.includes(user?.role || '');
    }
    return true;
  });

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      {/* Navigation Items */}
      <Box sx={{ flexGrow: 1, paddingX: 2, paddingY: 2 }}>
        {filteredNavMenu.map(item => (
          <NavItem
            key={item.title}
            item={item}
            isActive={
              location.pathname === item.href || location.pathname.startsWith(item.href + '/')
            }
          />
        ))}
      </Box>

      {/* Logout Button - Sticks to the bottom */}
      {user && (
        <Box
          display='flex'
          sx={{
            paddingX: 2,
            paddingY: 2,
            borderTop: '1px solid',
            borderColor: 'divider',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1,
          }}
        >
          {(user?.role === 'admin' || user?.role === 'super_admin') && (
            <Button
              onClick={handleConfigClick}
              endIcon={<SettingsIcon />}
              sx={theme => ({
                color: theme.palette.text.secondary,
                width: '100%',
                justifyContent: 'flex-start',
              })}
            >
              Configuración
            </Button>
          )}
          <Box display='flex' alignItems='center' justifyContent='center' width='100%'>
            <LogoutButton />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default memo(SidebarNav);
